import { VError } from 'errors';
import { LogStats, LogApiResponse } from 'types';
import { restService } from 'utilities';

export interface GetLogStatsOutput {
  stats: LogStats;
}

const getLogStats = async (): Promise<GetLogStatsOutput> => {
  const response = await restService<LogStats>({
    endpoint: '/logs/stats',
    method: 'GET',
  });

  if ('result' in response && response.result === 'error') {
    throw new VError({
      type: 'unexpected',
      code: 'somethingWentWrong',
      data: { message: response.message },
    });
  }

  if (!response.data?.data) {
    throw new VError({
      type: 'unexpected',
      code: 'somethingWentWrong',
      data: { message: 'No data received from API' },
    });
  }

  const apiData = response.data.data as unknown as LogApiResponse<LogStats>;

  if (!apiData.success) {
    throw new VError({
      type: 'unexpected',
      code: 'somethingWentWrong',
      data: { message: apiData.error || 'Failed to fetch log stats' },
    });
  }

  if (!apiData.data) {
    throw new VError({
      type: 'unexpected',
      code: 'somethingWentWrong',
      data: { message: 'No stats data received' },
    });
  }

  return {
    stats: apiData.data,
  };
};

export default getLogStats; 